import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  Divider,
  DividerProps,
  Drawer,
  DrawerProps,
  Paper,
  PaperProps,
  Stack,
  styled,
  Typography,
  TypographyProps,
} from '@mui/material';
import { forwardRef } from 'react';

import { doNotForwardTheseProps, elevationLevel } from '@/styles';

export const StyledInfoDrawer = styled(
  forwardRef<HTMLDivElement, DrawerProps>((props, ref) => (
    <Drawer ref={ref} slotProps={{}} {...props} />
  )),
)(({ theme }) => ({
  '&.MuiDrawer-modal': {
    zIndex: theme.zIndex.modal,

    '.MuiDrawer-paper': {
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      zIndex: theme.zIndex.modal,
    },
  },
}));

export const InfoDrawerContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(4),
  width: '100%',

  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
  },
}));

export const InfoModalContainer = styled(
  forwardRef<HTMLDivElement, PaperProps>((props, ref) => (
    <Paper ref={ref} elevation={elevationLevel.l} {...props} />
  )),
)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(5),
  width: 360,
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
}));

export const InfoReviewDrawerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

export const InfoReviewDrawerHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingBottom: 0,
  width: '100%',

  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
  },
}));

/**
 * @deprecated Use InfoReviewDetailCard instead
 */
export const InfoReviewDetailCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
}));

export const StyledInfoReviewDrawer = styled(
  forwardRef<HTMLDivElement, DrawerProps>((props, ref) => (
    <Drawer ref={ref} slotProps={{}} {...props} />
  )),
)(({ theme }) => ({
  padding: theme.spacing(4),
  '&.MuiDrawer-modal': {
    zIndex: theme.zIndex.modal,
    '.MuiDrawer-paper': {
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      zIndex: theme.zIndex.modal,
      backgroundColor: theme.palette.neutral[100],
    },
  },
}));

export const InfoReviewFieldSubValue = styled((props: TypographyProps) => (
  <Typography variant="caption" {...props} />
))(({ theme }) => ({
  marginTop: theme.spacing(0.5),
}));

export const InfoMenuDivider = styled((props: DividerProps) => (
  <Divider className="InfoMenuDivider" {...props} />
))(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
}));

export const InfoMenuButton = styled((props: ButtonProps) => (
  <Button variant="text" fullWidth {...props} />
))(({ theme }) => ({
  '&.MuiButton-root': {
    fontWeight: theme.typography.body2.fontWeight,
    justifyContent: 'flex-start',
  },
}));

export const UpdatePersonalInfoFormContainer = styled((props: BoxProps) => (
  <Box component="form" {...props} />
))(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

export const UpdatePersonalInfoDetailCard = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  width: '100%',
  padding: theme.spacing(2),
  alignItems: 'unset',
  WebkitAlignItems: 'unset',
  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
    padding: 0,
  },
}));

export const DocumentDrawer = styled(Drawer, {
  shouldForwardProp: doNotForwardTheseProps('bgColor'),
})<{ bgColor?: string }>(({ theme, bgColor }) => ({
  '.MuiDrawer-paper': {
    backgroundColor: bgColor || theme.palette.background.paper,
    [theme.breakpoints.up('lg')]: {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
